import {Injectable} from '@angular/core';
import {Constant} from "../common/constant";
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { createRequestOption } from '../common/utils/request-util';

@Injectable({ providedIn: 'root' })
export class ProfileService {

  constructor(
    private http: HttpClient,
    private localStorage: LocalStorageService, 
    private sessionStorage: SessionStorageService
  ) {}

  testLogin(data) {
    return this.http.post(environment.urlBackEnd + '',data)
    .pipe(map((res: any) => {
      const token = res.data.tokenType + " " + res.data.accessToken;
      return token;
    }))
  }
  getAccessCode() {
    return this.http.get(environment.urlBackEnd + '/users/get-access-code');
  }
  clear() {
    this.localStorage.store('TOKEN', '');
    this.sessionStorage.store('TOKEN', '');
  }
  confirmOTP(body) {
    return this.http.post(environment.urlBackEnd + '', body);
  }
  checkExist(body) {
    return this.http.post(environment.urlBackEnd + '', body);
  }
  signUp(body) {
    return this.http.post(environment.urlBackEnd + '', body);
  }
  confirmOTPRegister(body) {
    return this.http.post(environment.urlBackEnd + '', body);
  }
  forgotPassword(data) {
    return new Promise<boolean>((resolve, reject) =>{
      this.http.post(environment.urlBackEnd + '',data)
        .subscribe( (res: any)=>{
          if (res.status === Constant.success_code) {
              resolve(true)
          }
        })
    })
  }
  resendOTP(body) {
    return this.http.post(environment.urlBackEnd + '', body);
  }
  resendMail(data) {
    return new Promise<boolean>((resolve, reject) =>{
      this.http.post(environment.urlBackEnd + '',data)
        .subscribe((res: any)=>{
          if (res.status === Constant.success_code) {
            resolve(true)
          }
        })
    })
  }
  updateProfile(body) {
    return this.http.post(environment.urlBackEnd + 'users/profile', body);
  }
  changeAvatar(body) {
    return this.http.post(environment.urlBackEnd + 'users/change-avatar', body);
  }
  changePhoneOTP(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_security_otp_change_phone, body);
  }
  confirmUpdatePhone1(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_security_otp_confirm_phone_1, body);
  }
  confirmUpdatePhone2(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_security_otp_confirm_phone_2, body);
  }
  changeMailOTP(requestBody) {
    return  this.http.post(environment.urlBackEnd + Constant.api_security_otp_change_mail, requestBody);
  }
  confirmUpdateMail(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_security_otp_confirm_change_mail, body);
  }
  createAppointment(body) {
    return this.http.post(environment.urlBackEnd + 'users/register-consultation', body);
  }
  createAppointmentNoAuth(body) {
    return this.http.post(environment.urlBackEnd + 'auth/user/reg-advise', body);
  }
  queryAppointment(req){
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'users/consultation-list', { params: options, observe: 'response' });
  }
  queryContracts(req){
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'users/contract-list', { params: options, observe: 'response' });
  }
  queryDistricts(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'res/districts', { params: options, observe: 'response' });
  }
  queryWards(req) {
    const options = createRequestOption(req);
    return this.http.get(environment.urlBackEnd + 'res/wards', { params: options, observe: 'response' });
  }
}
